import { authService } from '../services'
import { router } from '../helpers'

const user = JSON.parse(localStorage.getItem('user'))
const state = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null }

const actions = {
  login ({ dispatch, commit }, user) {
    commit('loginRequest', user)

    authService.login(user)
      .then(
        user => {
          commit('loginSuccess', user)
          router.push('/')
          dispatch('alert/clear', null, { root: true })
          dispatch('alert/success', 'Successfully logged in.', { root: true })
        },
        error => {
          commit('loginFailure', error)
          dispatch('alert/error', error, { root: true })
        }
      )
  },
  logout ({ dispatch, commit }) {
    authService.logout()
    commit('logout')
    dispatch('alert/clear', null, { root: true })
  },
  register ({ dispatch, commit }, user) {
    commit('registerRequest', user)

    authService.register(user)
      .then(
        user => {
          commit('registerSuccess', user)
          router.push('/')
          dispatch('alert/success', 'Registration submitted for processing. You will contacted within 2 (two) business days.', { root: true })
        },
        error => {
          commit('registerFailure', error)
          dispatch('alert/error', error, { root: true })
        }
      )
  }
}

const mutations = {
  loginRequest (state, user) {
    state.status = { loggingIn: true }
    state.user = user
  },
  loginSuccess (state, user) {
    state.status = { loggedIn: true }
    state.user = user
  },
  loginFailure (state) {
    state.status = {}
    state.user = null
  },
  logout (state) {
    state.status = {}
    state.user = null
  },
  registerRequest (state, user) {
    state.status = { registering: true }
  },
  registerSuccess (state, user) {
    state.status = {}
  },
  registerFailure (state, error) {
    state.status = {}
  }
}

export const auth = {
  namespaced: true,
  state,
  actions,
  mutations
}
